import React, { useContext, useEffect, useState } from "react"
import { EventsContext, LanguageContext } from "../context"
import ShareModal from "../components/ShareModal"
import useEventActions from "../hooks/useEventActions"
import EventListItem from "../components/EventListItem"
import moment from "moment"
import { DATE_TIME_FORMAT } from "../utils/constants"

const MyEvents = () => {
  const { events, eventsLoading, eventsLoaded } = useContext(EventsContext)
  const [filteredEvents, setFilteredEvents] = useState([])
  const [futureEvents, setFutureEvents] = useState([])
  const [pastEvents, setPastEvents] = useState([])
  
  const { t } = useContext(LanguageContext)

  const { isEventOrganiser, isEventDriver, myEventVehicle, isVehiclePassenger, myVehiclePassengers, vehiclePassengers, isOnWaitlist, isEventParticipant, myWaitlistPassengers } = useEventActions({})

  const [shareModal, setShareModal] = useState({
    isOpen: false,
    event: {}
  })
  const [displayPastEvents, setDisplayPastEvents] = useState(false)

  useEffect(() => {
    const now = moment().valueOf()
    const fEvents = events.filter(isEventParticipant)
    setFilteredEvents(fEvents)
    const fFutureEvents = fEvents.filter(event => moment(event.end, DATE_TIME_FORMAT).valueOf() >= now).sort((a, b) => moment(a.start, DATE_TIME_FORMAT).valueOf() - moment(b.start, DATE_TIME_FORMAT).valueOf())
    setFutureEvents(fFutureEvents)
    const fPastEvents = fEvents.filter(event => moment(event.end, DATE_TIME_FORMAT).valueOf() < now).sort((a, b) => moment(b.start, DATE_TIME_FORMAT).valueOf() - moment(a.start, DATE_TIME_FORMAT).valueOf())
    setPastEvents(fPastEvents)
  }, [events])


  const handleShare = (event) => {
    setShareModal({ isOpen: true, event })
  }
  return (
    <div>
      {eventsLoading && <div className='global-loading'>
        <div className='global-loading__background' />
        <div className='global-loading__spinner' />
      </div>}
      {/* Has car */}
      <div className="content-parent">
        <div className="">
          {filteredEvents.length === 0 && <h4 className="event-title !text-center">{t('my_events.no_event')}</h4>}
          {futureEvents.map((event, eventIndex) => {
              return (
                <div key={`future-event-row-${eventIndex}`} className="mb-10">
                  <EventListItem event={event} eventIndex={eventIndex} handleShare={handleShare} />
                </div>
              )
            }
            )
          }
          {pastEvents.length > 0 && <div className="my-20">
            <button className="light mx-auto" onClick={() => setDisplayPastEvents(!displayPastEvents)}>
              <img src="/visibility.svg" />
              {t('event.past_events')}
            </button>
          </div>}
          {displayPastEvents && pastEvents.map((event, eventIndex) => {
              return (
                <div key={`past-event-row-${eventIndex}`} className="mb-10">
                  <EventListItem event={event} eventIndex={eventIndex} handleShare={handleShare} />
                </div>
              )
            }
            )
          }
        </div>
      </div>

      {shareModal.isOpen && <ShareModal showModal={shareModal.isOpen} onClose={() => setShareModal({ isOpen: false, event: {} })} event={shareModal.event} />}

    </div >
  )
}

export default MyEvents
